import React from "react";
import {useDynamicForm} from "../core/DynamicForm";
import {FormDrawer} from "./FormDrawer";

// Sentinel parent context for the root form. It is intentionally never provided,
// so the root FormDrawer always reads `null` and treats itself as the top-level
// form. Defined once at module scope instead of on every render.
const RootFormContext = React.createContext(null);

export function DynamicPageDrawer() {
    const {formData} = useDynamicForm()

    if (formData['type'] !== 'FORM') {
        return (
            <>
                Menu item is: {JSON.stringify(formData)}
            </>
        )
    }

    return (
        <FormDrawer config={formData} context={RootFormContext}/>
    )
}
